// extracted by mini-css-extract-plugin
export var description = "textarea-module--description--1f88d";
export var input = "textarea-module--input--e95c7";